import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "17",
  height: "22",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#fff",
  "fill-rule": "evenodd",
  d: "m5.444 13.503 5.901 2.728a3.02 3.02 0 0 1 1.527 1.558c.705 1.65-.259 3.336-1.772 3.943-1.513.606-3.126.216-3.86-1.5l-2.568-6.021c-.199-.467.301-.926.772-.708M5.798 11.737l6.092-2.303c2.025-.766 4.237.683 4.207 2.787l-.002.082c-.044 2.05-2.194 3.427-4.174 2.702l-6.117-2.24a.545.545 0 0 1-.006-1.028M5.457 10.939l5.988-2.545c1.99-.845 2.496-3.383.937-4.85l-.062-.058c-1.528-1.418-4.054-.918-4.924.95L4.71 10.208c-.215.46.27.934.748.731M3.916 9.933l2.177-5.97a2.9 2.9 0 0 0-.06-2.146C5.328.168 3.414-.364 1.9.243.388.851-.467 2.232.268 3.946l2.585 6.016c.2.466.889.447 1.063-.029",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }